import block from './block';
export default block;


// WEBPACK FOOTER //
// ./src/components/block/index.js